var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logDownloadPage"}},[(_vm.downloading)?_c('div',[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}}),_c('p',[_vm._v("Downloading "+_vm._s(_vm.filename)+"...")])],1):(_vm.error)?_c('div',[_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])]):_c('div',[_c('p',[_vm._v("Download complete.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }